module.exports = __webpack_public_path__ + "media/popup.4ab937d5.mp3";